import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=15f6f151&scoped=true&"
import script from "./EditableText.vue?vue&type=script&lang=js&"
export * from "./EditableText.vue?vue&type=script&lang=js&"
import style0 from "./EditableText.vue?vue&type=style&index=0&id=15f6f151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6f151",
  null
  
)

export default component.exports